import { SheetShell } from '../../components/boothly/sheet-shell.jsx';

// Gemeinsame Hülle der Live-Verkaufs-Sheets (Einzel, Spontan, Bundle) auf Basis der generischen
// SheetShell: eigenständig scrollender Info-Bereich (sale-scroll) und fixer Footer
// (sale-numpad-footer) im Daumenbereich.
export function SaleSheetShell({ open, onClose, title, leading, subtitle, children, footer, testId }) {
  return (
    <SheetShell
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      leading={leading}
      footer={footer}
      testId={testId}
      scrollTestId="sale-scroll"
      footerTestId="sale-numpad-footer"
    >
      {children}
    </SheetShell>
  );
}

// Primäre Verkaufen-Taste: 56pt, volle Breite, ganz unten im Daumenbereich.
export function SellButton({ amountLabel, disabled, onClick, label = 'Verkaufen' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="mt-3 flex h-14 w-full items-center justify-center rounded-[14px] bg-[var(--accent-troedel)] text-[18px] font-semibold text-white shadow-[var(--shine-button)] transition-[transform,opacity] duration-100 active:scale-[0.98] active:opacity-90 disabled:opacity-40 disabled:active:scale-100"
    >
      <span>{label}</span>
      <span className="mx-2 opacity-60">·</span>
      <span className="tabular-nums">{amountLabel}</span>
    </button>
  );
}
